import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LoadingController, ModalController, NavController, ToastController } from '@ionic/angular';
import { ModalSettingsComponent } from 'src/app/components/modals/modal-settings/modal-settings.component';
import { BankThatWeWorkViewModel } from 'src/app/models/bankThatWeWorkViewModel';
import { CoinViewModel } from 'src/app/models/coinViewModel';
import { BankService } from 'src/app/services/bank.service';
import { CoinService } from 'src/app/services/coin.service';

@Component({
  selector: 'app-bank-edit',
  templateUrl: './bank-edit.page.html',
  styleUrls: ['./bank-edit.page.scss'],
})
export class BankEditPage implements OnInit {

  form: FormGroup;
  coins: CoinViewModel[] = [];
  banks: BankThatWeWorkViewModel[] = [];
  bond = 0;
  typeKey = 0;

  constructor(private route: ActivatedRoute, private navCtrl: NavController, private service: BankService, private toastCtrl: ToastController,
              private fb: FormBuilder, private coinService: CoinService, private loadingCtrl: LoadingController, private modalCtrl: ModalController) {
    this.form = this.fb.group({
      id: [''],
      nameBank: ['PIX', Validators.compose([
        Validators.required
      ])],
      favored: ['', Validators.compose([
        Validators.minLength(10),
        Validators.maxLength(100),
        Validators.required
      ])],
      agency: ['', Validators.compose([
      ])],
      account: ['', Validators.compose([
      ])],
      document: ['', Validators.compose([
        Validators.required
      ])],
      bond: [0, Validators.compose([
        Validators.required
      ])],
      keyPix: [''],
      typeKeyPix: [0]
    });
  }

  async ngOnInit() {
    const loading = await this.loadingCtrl.create({ message: 'Carregando...' });
    loading.present();

    this.loadCoins();

    const id = this.route.snapshot.paramMap.get('id');

    if (id !== null) {
      this.service.getById(id).subscribe(result => {
        if (result.success) {
          this.populaForm(result.data);

          this.changeBanksWorksByCoin(this.form.get("bond").value);

          loading.dismiss();
          this.showMessage(result.message);
        } else {
          this.close();
          this.showMessage(result.message);
          loading.dismiss();
        }
      }, error => {
        this.close();
        this.showMessage(error.message);
        loading.dismiss();
      });
    }

    loading.dismiss();
  }

  async changeBanksWorksByCoin(event) {
    this.bond = event;
    
    const loading = await this.loadingCtrl.create({ message: 'Carregando...' });
    loading.present();

    this.service.getBankThatWeWorkByCoin(event).subscribe(result => {

      if (result.success) {
        this.banks = result.data;
        loading.dismiss();
      }
    });
  }

  async changeType(event){
    this.typeKey = event;
    this.form.patchValue({
      typeKeyPix: event,
      keyPix: "",
    });
  }

  loadCoins() {
    this.coinService.getCoin().subscribe(result => {
      if (result.success) {
        this.coins = result.data;
      }
    });
  }



  goToPage(page: string) {
    this.navCtrl.navigateForward(page);
  }

  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen, duration: 3000 });
    error.present();
  }

  populaForm(data) {

    this.typeKey = data.typeKeyPix;

    this.form.setValue({
      id: data.id,
      keyPix: data.keyPix,
      typeKeyPix: data.typeKeyPix,
      nameBank: data.nameBank,
      favored: data.favored,
      agency: data.agency,
      account: data.account,
      document: data.document,
      bond: data.bond,
    });
  }

  async save() {
    const loading = await this.loadingCtrl.create({ message: 'Salvando...' });
    loading.present();

    this.service.createBank(this.form.value).subscribe(result => {
      if (result.success) {
        loading.dismiss();
        this.close();
        this.showMessage(result.message);
      }
      this.showMessage(result.message);
      loading.dismiss();
    }, error => {
      this.showMessage(error.message);
    });
  }

  async close() {
    await this.goToPage('/master/wallet/bank');
  }

  async showModalSettings() {
    const modal = await this.modalCtrl.create({
      component: ModalSettingsComponent
    });
    modal.present();
  }
}
